import styled from 'styled-components';
import { colors } from 'src/config/colors';

export const SectionSubtitle = styled.div`
  color: ${colors.blue};
  font-size: 1.5rem;
  line-height: 1.875rem;
`;
